import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "bg-white p-4 rounded-lg mt-4" }
const _hoisted_2 = { class: "grid grid-cols-2 gap-y-6 gap-x-4 text-textPrimary" }
const _hoisted_3 = { class: "text-left" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", { class: "text-sm font-bold" }, "Data da solicitação", -1)
const _hoisted_5 = { class: "mt-1 text-sm" }
const _hoisted_6 = { class: "text-left" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h3", { class: "text-sm font-bold" }, "ID da solicitação", -1)
const _hoisted_8 = { class: "mt-1 text-sm" }
const _hoisted_9 = { class: "text-left" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h3", { class: "text-sm font-bold" }, "Prejuízo total", -1)
const _hoisted_11 = { class: "mt-1 text-sm text-negative" }
const _hoisted_12 = { class: "text-left" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h3", { class: "text-sm font-bold" }, "Solicitante", -1)
const _hoisted_14 = { class: "mt-1 text-sm" }
const _hoisted_15 = {
  key: 0,
  class: "text-left mt-6 text-textPrimary"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h3", { class: "text-sm font-bold" }, "Excepcionalidades aprovadas", -1)
const _hoisted_17 = { class: "mt-2 flex flex-wrap gap-2" }
const _hoisted_18 = {
  key: 1,
  class: "text-left mt-6 text-textPrimary"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h3", { class: "text-sm font-bold" }, "Excepcionalidades rejeitadas", -1)
const _hoisted_20 = { class: "mt-2 flex flex-wrap gap-2" }

import { computed } from 'vue'
import { format, parseISO } from 'date-fns'


export default /*#__PURE__*/_defineComponent({
  __name: 'ExceptionDetailsCard',
  props: {
    requestDate: {},
    requestId: {},
    totalLoss: {},
    requesterName: {},
    approvedExceptions: {},
    rejectedExceptions: {}
  },
  setup(__props: any) {

const props = __props;



const formattedRequestDate = computed(() => {
  if (!props.requestDate) return 'N/A'

  try {
    const date = parseISO(props.requestDate)
    return format(date, "dd/MM/yyyy 'às' HH:mm")
  } catch (error) {
    return 'Data inválida'
  }
})

const formattedRequestId = computed(() => `#${props.requestId}`)

const formattedTotalLoss = computed(() => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(props.totalLoss)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("p", _hoisted_5, _toDisplayString(formattedRequestDate.value), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("p", _hoisted_8, _toDisplayString(formattedRequestId.value), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("p", _hoisted_11, _toDisplayString(formattedTotalLoss.value), 1)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.requesterName), 1)
      ])
    ]),
    (_ctx.approvedExceptions && _ctx.approvedExceptions.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.approvedExceptions, (exception) => {
              return (_openBlock(), _createElementBlock("span", {
                key: exception,
                class: "px-1 py-1 text-sm text-slate-700 bg-neutral-100 border border-neutral-500 rounded-md"
              }, _toDisplayString(exception), 1))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.rejectedExceptions && _ctx.rejectedExceptions.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rejectedExceptions, (exception) => {
              return (_openBlock(), _createElementBlock("span", {
                key: exception,
                class: "px-1 py-1 text-sm text-slate-700 bg-neutral-100 border border-neutral-500 rounded-md"
              }, _toDisplayString(exception), 1))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})